import { message } from "antd";
import React, { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/api";
import { Container } from "./styles";
import Button from "../../components/Button";
import { useAuth } from "../../contexts/AuthContext";
import veloPrimeLogo from "../../assets/veloprime/logo-veloprime-horizontal-color.png";

const SSO: React.FC = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { setLocalStorageWithAuthData, signOut } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .post(
        "/auth/sso",
        {},
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        message.success("Logado com sucesso");
        signOut();
        setLoading(false);
        setLocalStorageWithAuthData(res.data);
      })
      .catch((err) => {
        message.error("Algo deu errado, tente novamente mais tarde.");
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [token]);

  return (
    <Container>
      <div className="sso-wrapper">
      <img src={veloPrimeLogo} alt="veloprime" />
        <div className="sso-area">
          {loading ? (
            <>
              <h4>Logando...</h4>
              <LoadingOutlined size={20} />
            </>
          ) : (
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="full-width"
              onClick={() => navigate("/p/login")}
            >
              Tentar fazer login manualmente
            </Button>
          )}
        </div>
      </div>
    </Container>
  );
};

export default SSO;
